import React from 'react'
import { ExperienceOfferPageState, INITIAL_EXPERIENCE_PAGE_STATE } from './experienceOfferPageStateReducer'

const ExperienceOfferPageStateContext = React.createContext<ExperienceOfferPageState>(INITIAL_EXPERIENCE_PAGE_STATE)

export default ExperienceOfferPageStateContext
